import { BCVectorMap, BCVectorMapEntities } from '@bimser/components';
import { FormItemTypes, IDictionary, MLHelper } from '@bimser/core';
import CompositeDataBoundControl from '../../base/CompositeDataBoundControl';
import {
	IAnnotation,
	IExportMap,
	ILayer,
	ILegend,
	ITitleMap,
	IVectorMapProperties
} from './entities';

export default class VectorMap extends CompositeDataBoundControl {
	bounds: string;
	controlBar: boolean;
	titleMap: ITitleMap;
	layer: ILayer[];
	legend: ILegend[];
	annotation: IAnnotation[];
	exportMap: IExportMap;

	constructor() {
		super();
		this.getTitleMap = this.getTitleMap.bind(this);
		this.getExportMap = this.getExportMap.bind(this);

		this.controlType = FormItemTypes.EControlTypes.VectorMap;

		this.bounds = '-180, 85, 180, -60';
		this.titleMap = {
			font: {
				color: 'rgb(0,0,0)',
				family: 'Source Sans Pro, sans-serif',
				size: 20
			},
			horizontalAlignment: 'center',
			subtitle: {
				text: {}
			},
			text: {},
			verticalAlignment: 'top'
		};
		this.caption.position = 'top';
		this.style.height = 350;
		this.layer = [
			{
				borderColor: 'rgb(0,0,0)',
				colorGroupingField: '',
				colorGroups: '',
				sizeGroupingField: '',
				sizeGroups: '',
				data: [],
				dataSource: 'World',
				hoverEnabled: true,
				hoveredColor: 'rgb(255,255,255)',
				name: '',
				palette: 'Violet'
			}
		];
		this.legend = [];
		this.controlBar = false;
		this.annotation = [];
		this.exportMap = {
			fileName: '',
			formats: 'JPEG',
			backgroundColor: 'rgb(255,255,255)',
			printingEnabled: false,
			enabled: false
		};
	}

	override __loadProperties(data: IVectorMapProperties): void {
		super.__loadProperties(data);
		this.__proxyChanged.bounds = data.bounds;
		this.__proxyChanged.controlBar = data.controlBar;
		this.__proxyChanged.titleMap = data.titleMap;
		this.__proxyChanged.layer = data.layer;
		this.__proxyChanged.legend = data.legend;
		this.__proxyChanged.annotation = data.annotation;
		this.__proxyChanged.exportMap = data.exportMap;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			bounds: this.bounds,
			controlBar: this.controlBar,
			titleMap: this.titleMap,
			layer: this.layer,
			legend: this.legend,
			annotation: this.annotation,
			exportMap: this.exportMap
		};
	}

	private getTitleMap(): BCVectorMapEntities.IVectorMapProps['titleMap'] {
		return {
			...this.titleMap,
			text: MLHelper.getMLText(this.titleMap.text)
		};
	}

	private getExportMap(): BCVectorMapEntities.IVectorMapProps['exportMap'] {
		return {
			...this.exportMap,
			formats: [this.exportMap.formats]
		};
	}

	override __render() {
		return super.__render(
			<BCVectorMap
				id={this.name}
				height={+this.style.height}
				controlBar={this.controlBar}
				bounds={this.bounds.split(',').map(Number)}
				layer={this.layer}
				legend={this.legend}
				annotation={this.annotation}
				titleMap={this.getTitleMap()}
				exportMap={this.getExportMap()}
			/>
		);
	}
}
